module.exports = __webpack_public_path__ + "static/media/audiofile.1b9ef533.svg";